import React, { Component } from "react";
import { Result, Button, } from "antd";
import { router } from "@/nano";

export default class ErrorBoundary extends Component {

  state = {
    message: "",
    hasError: false,
  };

  lastError = null;

  componentDidCatch(error, info) {
    this.lastError = error;
    this.setState({
      ...this.state,
      hasError: true,
      message: error.message,
    });
  }

  handleError = () => {
    this.setState({
      ...this.state,
      hasError: false,
    }, () => {
      const { code = "" } = this.lastError;
      if ("MODULE_NOT_FOUND" === code) {
        // 模块加载异常
        router.history.push("/");
      }
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="500"
          title="发生异常"
          subTitle={this.state.message}
          extra={
            <Button
              type="primary"
              onClick={this.handleError}
            >
              关闭
            </Button>
          }
        />
      )
    }
    return this.props.children;
  }
}
